/**
 * conversion: camelCase | kebab-case | capitalize | to boolean
 * * str is trimmed before converted
 */
export const camelize = (str) => {
  if ( typeof str !== 'string' ) return str;
  return str.trim().replace(/-([a-z])/g, (_, char) => char.toUpperCase());
};
export const kebabize = (str) => {
  if ( typeof str !== 'string' ) return str;
  return str.trim().replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
};
export const capitalize = (str, doByWord = true) => {
  if ( typeof str !== 'string' ) return str;
  const s = str.trim().toLowerCase();
  return doByWord
    ? s.replace(/\b\w/g, (match) => match.toUpperCase())
    : s.charAt(0).toUpperCase() + s.slice(1);
};
export const toBoolean = (str) => {
  if ( typeof str !== 'string' ) return str;
  const s = str.trim().toLowerCase();
  switch ( s ) {
    case 'true': return true;
    case 'false': return false;
    default: return str;
  }
};

/**
 * number | string | array | object => array
 * * space|comma separated string ('key1 key2', 'key1,key2') becomes array
 * * object key becomes string, even if number
 * @ options.isSeparated=true : 숫자를 각 자리로 분리할지 여부
 * @ - 1234 -> isseparated ? [1, 2, 3, 4] : [1234]
 * @ options.objectTo='keys|values|entries' : 객체를 변환할 기준
 */
export const toArray = (value, options = {}) => {
  if ( Array.isArray(value) ) return value; // for array, do nothing

  // null 또는 undefined -> 빈 배열 반환
  if ( value === null || typeof value === 'undefined' ) return [];

  if ( typeof value === 'number' ) {
    const { isSeparated = true } = options;
    return isSeparated ? String(value).split('').map(Number) : [value];
  }

  if ( typeof value === 'string' ) return value.trim().split(/[ ,]+/);

  if ( typeof value === 'object' && value !== null ) {
    const { objectTo = 'keys' } = options;
    const tos = ['keys', 'values', 'entries'];
    if ( !tos.includes(objectTo) ) {
      throw new Error(`'${objectTo}' is not supported: ${tos.join(', ')}are available.`);
    }
    return Object[objectTo](value);
  }

  return [value]; // 그 외의 경우 값을 그대로 배열에 담아 반환
};

/**
 * number | string | array : remove | reduce | manage whitespace
 * - reduce = multi to single + trim()
 * - for number, do nothing
 * whitespace management
 */
export const manageSpace = (value, how) => {
  const hows = ['trim', 'remove', 'reduce'];
  if ( !hows.includes(how) ) {
    throw new Error(`'${how}' is not supported: ${hows.join(', ')} are available.`);
  }

  // 배열인 경우, 각 항목에 대해 재귀적으로 함수를 호출합니다.
  if ( Array.isArray(value) ) {
    return value.map(item => manageSpace(item, how));
  }

  // 문자열이 아닌 경우, 원본 값을 그대로 반환
  if ( typeof value !== 'string' ) return value;

  switch ( how ) {
    case 'trim':
      return value.trim();
    case 'remove':
      return value.replace(/\s/g, '');
    case 'reduce':
      return value.replace(/\s+/g, ' ').trim();
    default:
      return value;
  }
};